import paper from 'paper'

// Don't automatically insert items into the scene graph, they must be explicitly inserted
paper.settings.insertItems = false

window.paper = paper
